import React, { PropsWithChildren } from "react";
import { clsx } from "clsx";

import { twMerge } from "@/design-system/twMerge";

// Figures use fixed primitive colors in both color modes, like a photo, and
// never take `dark:` overrides; only the backdrop token follows the mode. The
// color tokens have no skin tones, so these are hex values.
export const skinTones = {
  light: "fill-[#f2c7a5]",
  medium: "fill-[#dba27c]",
  deep: "fill-[#9c6644]",
};

type MascotFrameProps = PropsWithChildren<{
  className?: string;
  backdropClassName: string;
}>;

/** Clips a 48×48 portrait to a circle over a tinted backdrop. */
export function MascotFrame({
  className,
  backdropClassName,
  children,
}: MascotFrameProps) {
  return (
    <span
      aria-hidden
      className={twMerge(
        clsx(
          "inline-flex size-8 shrink-0 overflow-hidden rounded-full",
          backdropClassName,
          className,
        ),
      )}
    >
      <svg viewBox="0 0 48 48" focusable="false" className="size-full">
        {children}
      </svg>
    </span>
  );
}
